import InfoIcon from "Assets/Icons/InfoIcon";
import { useState } from "react";
import { Col, Progress, Row, Tooltip } from "reactstrap";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { roundToAnyDecimalPlaces } from "utilFunctions/helperFunctions/utilFunctions";
export const StyledSpanRating = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-weight: 600;
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "14px !important" : "12px"};
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  padding-left: 5px;
  padding-right: 5px;
`;
const StyledSpan = styled<any>("span")`
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "14px !important" : "10px"};
  color: ${(props: any) => props.color};
  font-style: normal;
  font-weight: 400;
  line-height: 17.043px; /* 150% */
`;
const IndicatorBarDiv = styled<any>("div")`
  position: relative;
  left: ${(props: any) => props.percentage - 2 + "%"};
  width: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "12px"};
  height: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "12px" : "6px"};
  top: -2px;
  background-color: ${(props: any) => props.color};
  clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
`;
const LOPRateMessageCol = styled<any>(Col)`
  color: #333333;
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px !important" : "12px"};
  padding-top: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "0px" : "8px"};
  padding-left: 0px;
  padding-right: 0px;
`;
const LopRatingCol = styled<any>(Col)`
  border-top: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "none" : "none"};
  background: #fff;
  margin-top: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "12px" : "0px"};
`;
export const ProgressStyled = styled<any>(Progress)`
  background-color: ${(props: any) => props.color + "! important"};
`;
export const getIndicatorColor = (percentage: number) => {
  if (percentage >= 0 && percentage <= 35) {
    return "#50B47F";
  } else if (percentage > 35 && percentage <= 50) {
    return "#FDA46D";
  } else if (percentage > 50 && percentage <= 65) {
    return "#FFD47F";
  } else {
    return "#E7685A";
  }
};
const StudentRatingComponent = ({ lopDetails }: any) => {
  const { screen }: any = useWindowSize();
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const ProgressBarWithIndicator = ({ percentage }: any) => {
    return (
      <div className="w-100">
        <IndicatorBarDiv
          percentage={percentage}
          color={percentage > 0 ? getIndicatorColor(percentage) : "#AFAFAF"}
          screen={screen}
        ></IndicatorBarDiv>
        <Progress multi className="studentProgressMB">
          <ProgressStyled
            bar
            color={percentage > 0 ? "#50B47F" : "#AFAFAF"}
            value="35"
          ></ProgressStyled>
          <ProgressStyled
            bar
            color={percentage > 0 ? "#FDA46D" : "#CBCBCB"}
            value="15"
          ></ProgressStyled>
          <ProgressStyled
            bar
            color={percentage > 0 ? "#FFD47F" : "#E2E2E2"}
            value="15"
          ></ProgressStyled>
          <ProgressStyled
            bar
            color={percentage > 0 ? "#E7685A" : "#F5F5F5"}
            value="35"
          ></ProgressStyled>
        </Progress>
      </div>
    );
  };
  return (
    <Row className="w-100">
      <LopRatingCol md="12" screen={screen}>
        <Row className="d-flex align-items-center m-0">
          <LOPRateMessageCol
            screen={screen}
            xxl="4"
            xl="4"
            lg="5"
            md="4"
            sm="3"
            xs="4"
          >
            LOP Risk:
            <span className="percentageSpan pl-1">
              {lopDetails && lopDetails.probability * 100
                ? roundToAnyDecimalPlaces(lopDetails.probability * 100, 0) +
                  " %"
                : "NA"}
            </span>
          </LOPRateMessageCol>
          <LOPRateMessageCol
            xxl="1"
            xl="1"
            lg="2"
            md="2"
            sm="2"
            xs="1"
            screen={screen}
          >
            <StyledSpan screen={screen} color="#757575">
              Low
            </StyledSpan>
          </LOPRateMessageCol>
          <LOPRateMessageCol
            xxl="6"
            xl="4"
            lg="4"
            md="4"
            sm="4"
            xs="4"
            className="d-flex align-items-center"
            screen={screen}
          >
            <ProgressBarWithIndicator
              percentage={(lopDetails && lopDetails.probability * 100) || 0}
            />
          </LOPRateMessageCol>
          <LOPRateMessageCol
            xxl="1"
            xl="1"
            lg="1"
            md="1"
            sm="1"
            xs="1"
            className="d-flex align-items-center pr-1 pl-2"
            screen={screen}
          >
            <StyledSpan screen={screen} color="#757575">
              High
            </StyledSpan>
          </LOPRateMessageCol>
          <LOPRateMessageCol
            xxl="1"
            xl="1"
            lg="1"
            md="1"
            sm="1"
            xs="1"
            className="pl-2 d-flex align-items-center"
            screen={screen}
          >
            <InfoIcon id={"Tooltip-attendance2"}></InfoIcon>
            <Tooltip
              placement={"top"}
              isOpen={tooltipOpen}
              target={"Tooltip-attendance2"}
              toggle={toggle}
            >
              LOP Risk % represents the chance of a student leaving the
              institute, determined by analyzing performance, attendance, and
              other relevant data.
            </Tooltip>
          </LOPRateMessageCol>
        </Row>
      </LopRatingCol>
    </Row>
  );
};
export default StudentRatingComponent;
